export { default as ResetSearchOnUnMount } from './reset-search-on-unmount';
